import { BASE_URL_API } from "../../../constants";
import fetcher from "../../../utils/fetcher";

const get = (path, searchParams) => {
    const params = searchParams ? `?${searchParams}` : "";
    return fetcher(`${BASE_URL_API}/hr/pilotage/${path}${params}`, {
        method: "GET",
        credentials: "include",
    });
};

/** GET /api/hr/pilotage/effectif?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_effectif = (searchParams) =>
    get("effectif", searchParams);

/** GET /api/hr/pilotage/diversite?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_diversite = (searchParams) =>
    get("diversite", searchParams);

/** GET /api/hr/pilotage/retention?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_retention = (searchParams) =>
    get("retention", searchParams);

/** GET /api/hr/pilotage/mouvements?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_mouvements = (searchParams) =>
    get("mouvements", searchParams);

/** GET /api/hr/pilotage/absenteisme?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_absenteisme = (searchParams) =>
    get("absenteisme", searchParams);

/** GET /api/hr/pilotage/temps-travail?agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_temps_travail = (searchParams) =>
    get("temps-travail", searchParams);

/** GET /api/hr/pilotage/frais?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_frais = (searchParams) =>
    get("frais", searchParams);

/** GET /api/hr/pilotage/taches?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_taches = (searchParams) =>
    get("taches", searchParams);
